module.exports = __webpack_public_path__ + "img/keen_model_4.9d5d23a6.jpg";